import React from "react";
import PropTypes from "prop-types";
import { SiOpenai, SiGoogle, SiMeta } from "react-icons/si";
import { FaBrain, FaMicrochip, FaRobot } from "react-icons/fa";

// Map an LLM model name to its provider icon + brand color.
const modelMeta = (model) => {
  const m = String(model || "").toLowerCase();
  if (/^(gpt|o1|o3|o4|text-|davinci|chatgpt)/.test(m)) return { Icon: SiOpenai, color: "#10a37f", label: "OpenAI" };
  if (m.includes("claude")) return { Icon: FaBrain, color: "#d97757", label: "Anthropic" };
  if (m.includes("gemini") || m.includes("palm")) return { Icon: SiGoogle, color: "#4285f4", label: "Google" };
  if (m.includes("llama")) return { Icon: SiMeta, color: "#0866ff", label: "Meta" };
  if (/mistral|mixtral|qwen|phi|gemma|deepseek/.test(m)) return { Icon: FaMicrochip, color: "#64748b", label: "Local model" };
  return { Icon: FaRobot, color: "#94a3b8", label: "Model" };
};

// Model name prefixed with its provider icon (brand-colored) for a polished look.
const ModelBadge = ({ model, size = 13, className = "" }) => {
  if (!model) return <span className="tw-text-slate-300">—</span>;
  const { Icon, color, label } = modelMeta(model);
  return (
    <span className={`tw-inline-flex tw-items-center tw-gap-1.5 ${className}`} title={label}>
      <Icon size={size} style={{ color }} className="tw-shrink-0" />
      <span className="tw-truncate">{model}</span>
    </span>
  );
};
ModelBadge.propTypes = { model: PropTypes.string, size: PropTypes.number, className: PropTypes.string };

export default ModelBadge;
